export default (editor, opts = {}) => {
  const bm = editor.BlockManager;
  
  bm.add('table-block', {
    label: 'Table',
    category: 'Basic',
    media: `<span class="fa-solid fa-table"></span>`,
    // attributes: {
    //   class: 'fa-solid fa-table'
    // },
    content: {
      type: 'customTable',
    },
    activate: true,
  });
};
